import React from "react";
import { Button } from "react-bootstrap";

import classNames from "classnames";

import { IOrderProduct } from "../../../../../types/api";

interface Props {
    handleShow: (modal: string) => void;
    product: IOrderProduct;
}

const OrderManagementButtons = ({
    handleShow,
    product,
}: Props): React.JSX.Element => {
    return (
        <div className={classNames("orderManagementButtons")}>
            <Button
                type="button"
                variant="primary"
                onClick={() => handleShow("cancelProduct")}
            >
                Cancel Registration
            </Button>
            <Button
                type="button"
                variant="primary"
                onClick={() => handleShow("changeProduct")}
            >
                Move team to new Tournament
            </Button>
        </div>
    );
};

export default OrderManagementButtons;
